// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  margin: 0 auto;
}

.module {
  border: 1px solid #ddd;
  margin-bottom: 20px;
  padding: 15px;
  border-radius: 5px;
}

.module-title {
  font-size: 1.2em;
  font-weight: bold;
  margin-bottom: 10px;
  color: #0056b3;
}

label {
  display: block;
  margin-bottom: 5px;
}

input[type=text],
textarea {
  width: 100%;
  padding: 8px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box; /* Ensures padding doesn't affect width */
}

input[type=file] {
  margin-bottom: 10px;
}

.step {
  margin-bottom: 15px;
}

button {
  background-color: #0056b3;
  color: white;
  padding: 10px 15px;
  border: none;
  margin-bottom: 20px;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background-color: #003366;
}

.navigation {
  margin-top: 20px;
  text-align: center;
}

.navigation button {
  margin: 0 5px;
}

#progress-bar-container {
  width: 100%;
  background-color: #f3f3f3;
  border-radius: 5px;
  margin-bottom: 20px;
}

#progress-bar {
  width: 20%; /* Starts at 0%, adjust based on module completed */
  height: 20px;
  background-color: #4caf50;
  text-align: center;
  line-height: 20px;
  color: white;
  border-radius: 5px;
}

.hidden {
  display: none;
}

/* .header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 80px;
    background-color: #f8f9fa;
  }

  .logo-container {
    text-align: center;
    flex: 1;
  }

  .logo {
    width: 85px;
    height: 85;
    object-fit: cover;
  }

  .app-name {
    font-size: 24px;
    font-weight: bold;
    margin-top: 10px;
  } */
.user-panel {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.user-image-container {
  position: relative;
}

.user-image {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #ccc;
}

.user-status-circle {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 10px;
  height: 10px;
  background-color: green;
  border-radius: 50%;
  border: 2px solid white;
}

.logout-button {
  margin-left: 15px;
}

.logout-button .btn {
  padding: 5px 10px;
  font-size: 14px;
}

.user-panel-options {
  display: block; /* Ensures the panel is shown when isPanelVisible is true */
  position: absolute;
  top: 40px; /* Adjust the position */
  left: 0;
  background: white;
  border: 1px solid #ddd;
  padding: 10px;
  list-style: none;
}

.user-panel-options ul {
  margin: 0;
  padding: 0;
}

.user-panel-options li {
  margin: 5px 0;
}

.user-panel-options li a {
  text-decoration: none;
  color: #333;
}

.border-theme {
  color: #1c625b;
  border-color: #00a95c;
}

.user-panel-options li a:hover {
  color: #007bff;
}

/* Styling the rounded panel containing the header */
.rounded-panel {
  display: flex;
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 15px;
  padding: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
  margin-top: 10px;
}

/* Vertical line before the header */
.vertical-line {
  height: 40px;
  width: 4px;
  background-color: #646464;
  margin-right: 15px;
}

/* Page title styles */
.page-title {
  font-size: 20px;
  color: #797979;
  text-align: left;
  margin: 0; /* Remove default margin */
  font-weight: 600;
}

/* Stepper Card Styling */
.card {
  border-radius: 2px;
  border: none;
  background: #ffffff;
  margin-bottom: 20px;
}

/* Wizard Header */
.wizard-header {
  display: flex;
  justify-content: space-between;
  position: relative;
  margin-bottom: 20px;
  padding-bottom: 10px;
}

/* Progress Line */
.wizard-header::before {
  content: "";
  position: absolute;
  top: 20px;
  left: 10%;
  width: 80%;
  height: 4px;
  background: #ddd;
  z-index: 0;
}

/* Individual Steps */
.wizard-step {
  text-align: center;
  position: relative;
  z-index: 1;
  flex: 1;
  cursor: pointer;
}

/* Step Circle */
.step-circle {
  width: 40px;
  height: 40px;
  background: #ccc;
  color: #fff;
  font-weight: bold;
  font-size: 18px;
  border-radius: 50%;
  line-height: 40px;
  margin: auto;
  transition: all 0.3s ease;
}

/* Step Label */
.step-label {
  display: block;
  font-size: 14px;
  margin-top: 5px;
  font-weight: bold;
  color: #777;
}

/* Active Step Styling */
.wizard-step.active .step-circle {
  background: rgb(70, 159, 84);
}

.wizard-step.active .step-label {
  color: rgb(70, 159, 84);
}

/* Progress Line for Completed Steps */
.wizard-step.active ~ .wizard-step .step-circle {
  background: #ccc;
}

cdk-step .cdk-step-header {
  display: none !important;
}

.btn-submit {
  background-color: #00a95c;
}

.btn {
  margin-top: 20px;
  margin-right: 10px; /* Corrected margin syntax */
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/features/demandes/components/completsavemedicament/completsavemedicament.component.scss"],"names":[],"mappings":"AAAA;EAEE,cAAA;AAAF;;AAGA;EACE,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AAAF;;AAGA;EACE,cAAA;EACA,kBAAA;AAAF;;AAGA;;EAEE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA,EAAA,yCAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAAF;;AAGA;EACE,yBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,aAAA;AAAF;;AAEA;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,UAAA,EAAA,mDAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;;;;;;;;;;;;;;;;;;;;;;;KAAA;AAyBA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,uBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;EACA,eAAA;AAAF;;AAGA;EACE,cAAA,EAAA,2DAAA;EACA,kBAAA;EACA,SAAA,EAAA,wBAAA;EACA,OAAA;EACA,iBAAA;EACA,sBAAA;EAEA,aAAA;EACA,gBAAA;AADF;;AAIA;EACE,SAAA;EACA,UAAA;AADF;;AAIA;EACE,aAAA;AADF;;AAIA;EACE,qBAAA;EACA,WAAA;AADF;;AAGA;EACE,cAAA;EACA,qBAAA;AAAF;;AAEA;EACE,cAAA;AACF;;AACA,oDAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,wCAAA;EACA,mBAAA;EACA,gBAAA;AAEF;;AACA,oCAAA;AACA;EACE,YAAA;EACA,UAAA;EACA,yBAAA;EACA,kBAAA;AAEF;;AACA,sBAAA;AACA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA,EAAA,0BAAA;EACA,gBAAA;AAEF;;AAAA,yBAAA;AACA;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AAGF;;AAAA,kBAAA;AACA;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;AAGF;;AAAA,kBAAA;AACA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;AAGF;;AAAA,qBAAA;AACA;EACE,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,OAAA;EACA,eAAA;AAGF;;AAAA,gBAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,yBAAA;AAGF;;AAAA,eAAA;AACA;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;AAGF;;AAAA,wBAAA;AACA;EACE,4BAAA;AAGF;;AAAA;EACE,uBAAA;AAGF;;AAAA,sCAAA;AACA;EACE,gBAAA;AAGF;;AADA;EACE,wBAAA;AAIF;;AADA;EACE,yBAAA;AAIF;;AADA;EACE,gBAAA;EACA,kBAAA,EAAA,4BAAA;AAIF;AACA,onTAAonT","sourcesContent":[".container {\n  // max-width: 600px;\n  margin: 0 auto;\n}\n\n.module {\n  border: 1px solid #ddd;\n  margin-bottom: 20px;\n  padding: 15px;\n  border-radius: 5px;\n}\n\n.module-title {\n  font-size: 1.2em;\n  font-weight: bold;\n  margin-bottom: 10px;\n  color: #0056b3;\n}\n\nlabel {\n  display: block;\n  margin-bottom: 5px;\n}\n\ninput[type=\"text\"],\ntextarea {\n  width: 100%;\n  padding: 8px;\n  margin-bottom: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-sizing: border-box; /* Ensures padding doesn't affect width */\n}\n\ninput[type=\"file\"] {\n  margin-bottom: 10px;\n}\n\n.step {\n  margin-bottom: 15px;\n}\n\nbutton {\n  background-color: #0056b3;\n  color: white;\n  padding: 10px 15px;\n  border: none;\n  margin-bottom: 20px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\nbutton:hover {\n  background-color: #003366;\n}\n\n.navigation {\n  margin-top: 20px;\n  text-align: center;\n}\n\n.navigation button {\n  margin: 0 5px;\n}\n#progress-bar-container {\n  width: 100%;\n  background-color: #f3f3f3;\n  border-radius: 5px;\n  margin-bottom: 20px;\n}\n\n#progress-bar {\n  width: 20%; /* Starts at 0%, adjust based on module completed */\n  height: 20px;\n  background-color: #4caf50;\n  text-align: center;\n  line-height: 20px;\n  color: white;\n  border-radius: 5px;\n}\n\n.hidden {\n  display: none;\n}\n\n/* .header-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 15px 80px;\n    background-color: #f8f9fa;\n  }\n  \n  .logo-container {\n    text-align: center;\n    flex: 1;\n  }\n  \n  .logo {\n    width: 85px;\n    height: 85;\n    object-fit: cover;\n  }\n  \n  .app-name {\n    font-size: 24px;\n    font-weight: bold;\n    margin-top: 10px;\n  } */\n\n.user-panel {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.user-image-container {\n  position: relative;\n}\n\n.user-image {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 2px solid #ccc;\n}\n\n.user-status-circle {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 10px;\n  height: 10px;\n  background-color: green;\n  border-radius: 50%;\n  border: 2px solid white;\n}\n\n.logout-button {\n  margin-left: 15px;\n}\n\n.logout-button .btn {\n  padding: 5px 10px;\n  font-size: 14px;\n}\n\n.user-panel-options {\n  display: block; /* Ensures the panel is shown when isPanelVisible is true */\n  position: absolute;\n  top: 40px; /* Adjust the position */\n  left: 0;\n  background: white;\n  border: 1px solid #ddd;\n  // box-shadow: 0 0 10px rgba(255, 255, 255, 0.1);\n  padding: 10px;\n  list-style: none;\n}\n\n.user-panel-options ul {\n  margin: 0;\n  padding: 0;\n}\n\n.user-panel-options li {\n  margin: 5px 0;\n}\n\n.user-panel-options li a {\n  text-decoration: none;\n  color: #333;\n}\n.border-theme {\n  color: #1c625b;\n  border-color: #00a95c;\n}\n.user-panel-options li a:hover {\n  color: #007bff;\n}\n/* Styling the rounded panel containing the header */\n.rounded-panel {\n  display: flex;\n  align-items: center;\n  background-color: #f5f5f5;\n  border-radius: 15px;\n  padding: 15px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  margin-bottom: 10px;\n  margin-top: 10px;\n}\n\n/* Vertical line before the header */\n.vertical-line {\n  height: 40px;\n  width: 4px;\n  background-color: #646464;\n  margin-right: 15px;\n}\n\n/* Page title styles */\n.page-title {\n  font-size: 20px;\n  color: #797979;\n  text-align: left;\n  margin: 0; /* Remove default margin */\n  font-weight: 600;\n}\n/* Stepper Card Styling */\n.card {\n  border-radius: 2px;\n  border: none;\n  background: #ffffff;\n  margin-bottom: 20px;\n}\n\n/* Wizard Header */\n.wizard-header {\n  display: flex;\n  justify-content: space-between;\n  position: relative;\n  margin-bottom: 20px;\n  padding-bottom: 10px;\n}\n\n/* Progress Line */\n.wizard-header::before {\n  content: \"\";\n  position: absolute;\n  top: 20px;\n  left: 10%;\n  width: 80%;\n  height: 4px;\n  background: #ddd;\n  z-index: 0;\n}\n\n/* Individual Steps */\n.wizard-step {\n  text-align: center;\n  position: relative;\n  z-index: 1;\n  flex: 1;\n  cursor: pointer;\n}\n\n/* Step Circle */\n.step-circle {\n  width: 40px;\n  height: 40px;\n  background: #ccc;\n  color: #fff;\n  font-weight: bold;\n  font-size: 18px;\n  border-radius: 50%;\n  line-height: 40px;\n  margin: auto;\n  transition: all 0.3s ease;\n}\n\n/* Step Label */\n.step-label {\n  display: block;\n  font-size: 14px;\n  margin-top: 5px;\n  font-weight: bold;\n  color: #777;\n}\n\n/* Active Step Styling */\n.wizard-step.active .step-circle {\n  background: rgb(70, 159, 84);\n}\n\n.wizard-step.active .step-label {\n  color: rgb(70, 159, 84);\n}\n\n/* Progress Line for Completed Steps */\n.wizard-step.active ~ .wizard-step .step-circle {\n  background: #ccc;\n}\ncdk-step .cdk-step-header {\n  display: none !important;\n}\n\n.btn-submit {\n  background-color: #00a95c;\n}\n\n.btn {\n  margin-top: 20px;\n  margin-right: 10px; /* Corrected margin syntax */\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
